module.exports = __webpack_public_path__ + "img/4.49f35d35.png";